import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const welcome = params.get("welcome") === "1";
  const navigate = useNavigate();
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 6) return toast.error("La password deve avere almeno 6 caratteri");
    if (pwd !== confirm) return toast.error("Le password non coincidono");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pwd });
      toast.success(welcome ? "Password creata, benvenuto! Ora accedi con la tua email" : "Password aggiornata, accedi con la nuova password");
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Token non valido o scaduto");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="reset-password-page">
      <Card className="w-full max-w-md p-8 glow-border">
        <Logo size={26} />
        <div className="flex items-center gap-2 mt-6"><KeyRound className="w-5 h-5 text-primary" /><h1 className="font-head text-2xl font-bold" data-testid="reset-title">{welcome ? "Benvenuto in Markoo Place" : "Reimposta password"}</h1></div>
        {welcome && token && <p className="text-sm text-muted-foreground mt-2" data-testid="welcome-intro">Scegli la tua password personale per entrare nella nuova piattaforma.</p>}
        {!token ? (
          <p className="text-sm text-amber-500 mt-4" data-testid="reset-no-token">Link non valido: token mancante. Richiedi un nuovo link dalla pagina di accesso.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-6">
            <div><Label>Nuova password</Label><Input type="password" required className="mt-1.5" data-testid="reset-password-input" value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder="••••••••" /></div>
            <div><Label>Conferma password</Label><Input type="password" required className="mt-1.5" data-testid="reset-confirm-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="••••••••" /></div>
            <Button type="submit" disabled={loading} className="w-full" data-testid="reset-submit-button">{loading ? "Salvataggio…" : welcome ? "Crea password ed entra" : "Aggiorna password"}</Button>
          </form>
        )}
      </Card>
    </div>
  );
}
